<small class="debug"> {{me}} </small>
<div>
  <h2 class="form-signin-heading"></h2>
  <mat-form-field>
    <mat-label>{{'account.userNameOrEmail' | transloco}}</mat-label>
    <input [disabled]="m_disableInput" inputrestriction="login" (invalidCharacter)="messageInvalidCharChosen($event)" matInput spellcheck="false" type="text" name="m_user" [(ngModel)]="m_loginName" placeholder="" required autofocus>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'account.oldPassword' | transloco}}</mat-label>
    <input matInput inputrestriction="password" [opts]="'password'" (invalidCharacter)="messageInvalidCharChosen($event)"  type="password" [(ngModel)]="m_pass" name="m_pass" placeholder="" required>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{'account.newPassword' | transloco}}</mat-label>
    <input matInput inputrestriction="password" (keyup)="onKeyUpPasswordDev()" [opts]="'password'" (invalidCharacter)="messageInvalidCharChosen($event)"  type="password" [(ngModel)]="m_passNew" name="m_pass" placeholder="" required>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'account.repeatPass' | transloco}}</mat-label>
    <input matInput inputrestriction="password" [opts]="'password'" (invalidCharacter)="messageInvalidCharChosen($event)"  type="password" [(ngModel)]="m_passRepeat" name="m_pass" placeholder="" required>
  </mat-form-field>
  <br/>
  <br/>
  <button type="submit" (click)="onChangePassword()" class="sub" mat-stroked-button color="primary">
    {{'account.changePassword' | transloco}}
    <mat-icon style="font-size: 1.3em; position: absolute; right: 10px">vpn_key</mat-icon>
  </button>
  <br/>
  <br/>
  @if (!hideBack) {
    <a color="warn" class="pull-left" (click)="$event.preventDefault(); setViewMode(m_viewMod.LOGIN)" href="#">
      <mat-icon style="position: relative; top: 6px">chevron_left</mat-icon>
      {{'general.back' | transloco}}
    </a>
  }
</div>
